/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Chat_Space_File_Version_FromInputs */



/**
* | output |
* | --- |
* | "Version replaced on: {date}" |
*
* @param {Chat_Space_File_Version_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_space_file_version_from = /** @type {((inputs: Chat_Space_File_Version_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Space_File_Version_FromInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Fassung ersetzt am: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Version replaced on: ${i?.date}`)
});